import { ref, Ref } from 'vue'

let instance: any = null

export type GalleryBoxOptions = {
    onRemove?: (index: number, url?: string) => unknown
    onAdd?: (file: string, filename?: string) => Promise<string | string[] | void> | string | string[] | void
    adding?: boolean
}

const createInstance = () => {
    const images: Ref<string[]> = ref([])
    const current: Ref<number> = ref(0)
    const visible: Ref<boolean> = ref(false)
    const onRemove: Ref<GalleryBoxOptions['onRemove']> = ref(null)
    const onAdd: Ref<GalleryBoxOptions['onAdd']> = ref(null)
    const startAdding: Ref<boolean> = ref(false)

    const show = (imgs: string[], curr = 0, options: GalleryBoxOptions = {}) => {
        images.value = imgs
        current.value = curr
        visible.value = true
        onRemove.value = options.onRemove
        onAdd.value = options.onAdd
        startAdding.value = !!options.adding
    }

    const dismiss = () => {
        images.value = []
        visible.value = false
        onRemove.value = null
        onAdd.value = null
        startAdding.value = false
    }

    return {
        images,
        current,
        visible,
        onRemove,
        onAdd,
        startAdding,
        show,
        dismiss
    }
}

export const useGalleryBox = () => {
    if (instance) {
        return {
            galleryBox: instance
        }
    }
    instance = createInstance()
    return {
        galleryBox: instance
    }
}
